import { inject, Injectable } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { CustomerAttribute } from '@df/catalog/customer-attribute/customer-attribute';
import { Resource } from '@df/catalog/resource';
import { WINDOW } from '@df/dom/globals';

declare module '@df/catalog/resource' {
    interface IResources {
        customerAttribute: Resource<CustomerAttribute, string>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerAttributeResource extends Resource<CustomerAttribute, string> {
    static override instance = CustomerAttribute;
    readonly invalidatesUniversal = false;
    readonly invalidatesPrerender = false;

    private window = inject(WINDOW);

    protected constructor() {
        super();
        this.app.resources.customerAttribute = this;
        (this.window.autoInitData as any)?.data?.customerAttribute?.forEach((customerAttributeData: Catalog.ICustomerAttributeData) => {
            this.app.resources.customerAttribute.getCreate(customerAttributeData.code).setData(customerAttributeData);
        });
    }
}
